import type { NextPage } from 'next'
import { useTranslation } from 'next-i18next'

import { Terms } from '@/components/blocks/Document/Terms'
import { Layout } from '@/components/layouts/Layout'
import { getStaticPropsTranslations } from '@/utils/i18n'

const TermsPage: NextPage = () => {
  const { t } = useTranslation()

  return (
    <Layout
      seo={{
        title: 'Terms of Service | Nutria',
        description: t('cl_landing_terms_of_service_meta_description'),
      }}
    >
      <Terms />
    </Layout>
  )
}

export default TermsPage

export async function getStaticProps({ locale }: { locale: string }) {
  return {
    props: {
      ...(await getStaticPropsTranslations(locale)),
    },
  }
}
